import React, { FC, ReactElement } from 'react';
import { TMS_ADMIN_TOKEN } from '@/utils/constants';
import { useCookieState } from 'ahooks';
import { Navigate } from 'react-router-dom';

interface GuardProps {
  valid?: boolean;
  element: React.ReactNode;
}

const RouterGuard: FC<GuardProps> = ({ valid = true, element }) => {
  const [token] = useCookieState(TMS_ADMIN_TOKEN);
  if (valid) {
    if (token) {
      return element as ReactElement;
    }
    return <Navigate to='/login' />;
  } else {
    return element as ReactElement;
  }
};

export default RouterGuard;
